import React from 'react'
import PropTypes from 'prop-types'
// import { makeStyles } from '@material-ui/core/styles'

import AppBar from './Appbar';
import { Grid } from '@material-ui/core';

// const useStyles = makeStyles({
//   background1: {
//     height: '80px',
//     backgroundRepeat: 'repeat',
//     backgroundSize: 'auto',
//   },background2: {
//     height: '50px',
//     backgroundRepeat: 'repeat',
//     backgroundSize: '50px 50px',
//   }
// })

const Header = ({ siteMetaData }) => {

  return(
    <>
      <Grid container>
        <Grid item xs={12}>
          <AppBar siteMetaData={siteMetaData}></AppBar>
        </Grid>
      </Grid>
    </>
  )

}

Header.propTypes = {
  siteTitle: PropTypes.string,
}


export default Header